import {
  PrimaryTextColor,
  boldFont,
  centerItemFlex,
  getRelativeFontSize,
  primaryBlueColor,
  regularFont,
} from "../../../../../utils/styles";

const SignUpOtpStyles = {
  contentWrapper: {
    width: "100%",
    height: "100vh",
    ...centerItemFlex,
    flexDirection: "column",
    gap: 2,
  },
  cardHeader: {},
  cardTitle: {
    fontSize: getRelativeFontSize(10),
    ...boldFont,
    color: PrimaryTextColor,
  },
  cardSubText: {
    fontSize: getRelativeFontSize(),
    ...regularFont,
    color: PrimaryTextColor,
  },
  cardContent: {
    marginTop: 3,
  },
  cardFooter: {
    display: "flex",
    gap: "10px",
    flexDirection: "column",
    marginTop: 3,
  },
  signUpStyle: {
    fontSize: getRelativeFontSize(),
    ...regularFont,
  },

  emailIdLink: {
    color: primaryBlueColor,
    fontSize: getRelativeFontSize(),
    ...regularFont,
    marginTop  :"10px",
    "& a": {
      textDecoration: "none",
    },
  },
  sendOtpMgs : {
    color : "#6D6E82",
    fontSize :getRelativeFontSize(),
    marginTop : 2,
    marginBottom  :2
  }
};

export default SignUpOtpStyles;
